import { useEffect, useRef } from 'react'
import { io, Socket } from 'socket.io-client'
import { SOCKET } from '../configs/configs.js'

const useSocket = (callback: (socket: Socket) => void) => {
  const socketRef = useRef<Socket | null>(null)

  useEffect(() => {
    // Initialize the socket connection
    const socket = io(SOCKET.URL)
    socketRef.current = socket

    // Pass the socket to the callback function
    callback(socket)

    // Cleanup function
    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect()
        socketRef.current = null
      }
    }
  }, [callback])

  // Emit function
  const emitEvent = (eventName: string, data: any) => {
    if (socketRef.current) {
      socketRef.current.emit(eventName, data)
    } else {
      console.warn('Socket is not connected')
    }
  }

  return { socket: socketRef.current, emitEvent }
}

export default useSocket
